import { IHospitalConfigurationState } from '../types/hospitalConfiguration.types';

export const HOSPITAL_CONFIGURATION_INITIAL_STATE: IHospitalConfigurationState =
    {
        data: [],
        buildings: [],
        wings: [],
        floors: [],
        rooms: [],
        wards: [],
        beds: [],
        bedsByWard: [],
        admittedPatients: [],
        admittedPatientsTotalRecords: 0,
        admittedPatientsTotalPages: 0,
        admittedPatientsLoading: 'idle',
        loading: 'idle',
        error: null,
        selectedFacilityId: null,
    };

